import { withTemplates } from 'hocs';
import { useTemplatesFetch } from '../hooks/useTemplateFetch';
function TemplatesFetchImpl({ render, actions, templates, }) {
    useTemplatesFetch(templates, actions);
    return render(templates);
}
export const TemplatesFetch = withTemplates(TemplatesFetchImpl);
